import React from "react";
import PromosBannerContent from "../PromosBannerContent";
import {
  PromosBannerContainer,
  PromosBannerImageWrapper,
  PromosBannerImage,
  PromosMobileImage
} from "./styled-components";
import { PromosBannerProps } from "./types";

const PromosBanner = ({
  content = {
    pictureUrl: "",
    pictureAlt: "",
    mobilePictureUrl: "",
    categoryTitle: "",
    description: "",
    title: "",
    config: {
      ctaLabel: "",
      linkLabel: "",
      path: {
        id: undefined,
        url: "",
        cached_url: "",
        linktype: "url"
      },
      segment: "acq",
      promoCode: "",
      displayCTA: false,
      forOptin: false,
      enablePromoCode: false,
      promoId: "12345"
    }
  }
}: PromosBannerProps) => (
  <PromosBannerContainer data-qa-label="promosBannerContainer">
    <PromosBannerImageWrapper data-qa-label="promosBannerImageWrapper">
      <PromosBannerImage
        data-qa-label="promosBannerImage"
        src={content.pictureUrl}
        alt={content.pictureAlt}
      />
      <PromosMobileImage
        data-qa-label="promosBannerMobileImage"
        src={content.mobilePictureUrl}
        alt={content.pictureAlt}
      />
    </PromosBannerImageWrapper>
    <PromosBannerContent promosBannerItem={content} />
  </PromosBannerContainer>
);

export default PromosBanner;
